// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2hxdr","rowsWrapper":"style_rowsWrapper__2oaVO","rowWrapper":"style_rowWrapper__tOV0W","edit_wrapper":"style_edit_wrapper__2-0Zf"};